module.exports = function isTouchDevice() {
  return 'ontouchstart' in window || // works on most browsers
  navigator.maxTouchPoints; // works on IE10/11 and Surface
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@uppy/utils/lib/isTouchDevice.js
// module id = 1523
// module chunks = 0